import login   from '../pages/login/login'
import myPage  from '../pages/login/myPage'
import join1   from '../pages/login/join/join1'
import join2   from '../pages/login/join/join2'
import join3   from '../pages/login/join/join3'
import resetpassword   from '../pages/login/resetpw'
import findid   from '../pages/login/findid'

export default [
  { path: '/join-step1', name: 'join1', component: join1, meta: { step: 1 } },
  { path: '/join-step2', name: 'join2', component: join2, meta: { step: 2, requiresPrev: true } },
  { path: '/join-step3', name: 'join3', component: join3, meta: { step: 3, requiresPrev: true } },

  { path: '/login',  name: 'login',  component: login },
  { path: '/myPage', name: 'myPage', component: myPage },
  { path: '/reset-password', name: 'reset-password', component: resetpassword },
  { path: '/findid', name: 'findid', component: findid },

]
